import api from "./baseApi";
import endpoints from "./endpoints";

export const getReservations = async ({
  page = 1,
  perPage = 10,
  startDate,
  endDate,
  sortField,
  sortOrder,
  name,
  bookingRef,
  venueId,
  status,
  type,
  purpose,
  date,
} = {}) => {
  try {
    const params = {
      page,
      perPage,
    };

    // date range override (single-day or range)
    if (date) {
      params.startDate = date;
      params.endDate = date;
    } else if (startDate && endDate) {
      params.startDate = startDate;
      params.endDate = endDate;
    }

    // sorting
    if (sortField) params.sortField = sortField;
    if (sortOrder) params.sortOrder = sortOrder;

    // filters
    if (name) params.name = name;
    if (bookingRef) params.bookingRef = bookingRef;
    if (venueId) params.venueId = venueId;
    if (status) params.status = status;
    if (type) params.type = type;
    if (purpose) params.purpose = purpose;

    const res = await api.get(endpoints.reservation.base, { params });

    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to fetch reservations";

    throw new Error(message);
  }
};

export const getReservation = async (id) => {
  try {
    const res = await api.get(endpoints.reservation.detail(id));
    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to fetch reservation";

    throw new Error(message);
  }
};

export const createReservation = async (payload) => {
  try {
    const res = await api.post(endpoints.reservation.base, payload);
    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to create reservation";

    throw new Error(message);
  }
};

export const updateReservation = async (id, payload) => {
  try {
    const res = await api.put(endpoints.reservation.detail(id), payload);
    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to update reservation";

    throw new Error(message);
  }
};

export const deleteReservation = async (id) => {
  try {
    const res = await api.delete(endpoints.reservation.detail(id));
    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to delete reservation";

    throw new Error(message);
  }
};

export const resendReservationNotification = async (id) => {
  try {
    const res = await api.post(
      endpoints.reservation.resendNotification,
      { id }
    );

    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to resend notification";

    throw new Error(message);
  }
};

export const getArchivedReservations = async (
  page = 1,
  perPage = 20
) => {
  const res = await api.get(
    endpoints.reservation.archived,
    {
      params: {
        page,
        perPage,
      },
    }
  );

  return res.data;
};